<div class="line-chart tw-w-full tw-h-44">
  <canvas id="deviceDetailChart"></canvas>
</div>
